// ts-gql-integrity:eb7e539637642fcbc4d778b42a77cad1
/*
ts-gql-meta-begin
{
  "hash": "f6fbd870f3d2051d8d7e0057e5ec3cea"
}
ts-gql-meta-end
*/

import * as SchemaTypes from "./@schema";
import { TypedDocumentNode } from "@ts-gql/tag";

type Job_RecurrenceFragmentFragment = { recurrence: { cloudId: string, nextDateUtc: any | null, enabled: boolean, recurrenceFrequency: SchemaTypes.RecurrenceFrequency | null } };



export type type = TypedDocumentNode<{
  type: "fragment";
  result: Job_RecurrenceFragmentFragment;
  name: "Job_RecurrenceFragment";
  documents: SchemaTypes.TSGQLDocuments;
  fragments: SchemaTypes.TSGQLRequiredFragments<"none">
}>

declare module "./@schema" {
  interface TSGQLDocuments {
    Job_RecurrenceFragment: type;
  }
}

export const document = JSON.parse("{\"kind\":\"Document\",\"definitions\":[{\"kind\":\"FragmentDefinition\",\"name\":{\"kind\":\"Name\",\"value\":\"Job_RecurrenceFragment\"},\"typeCondition\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"Job\"}},\"directives\":[],\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"recurrence\"},\"arguments\":[],\"directives\":[],\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"cloudId\"},\"arguments\":[],\"directives\":[]},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"nextDateUtc\"},\"arguments\":[],\"directives\":[]},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"enabled\"},\"arguments\":[],\"directives\":[]},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"recurrenceFrequency\"},\"arguments\":[],\"directives\":[]}]}}]}}]}")
